import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { FolderMenuRefreshEvent } from 'src/app/models/events/folder-menu-refresh-event';

@Injectable({
    providedIn: 'root',
})
export class FolderMenuRefreshEventsService {
    /**
     * Emis lorsque le menu d'un dossier doit être rechargé
     */
    public needRefresh = new Subject<FolderMenuRefreshEvent>();
}
